import {
  OAUTH_CALLBACK,
  PASSWORD_RESET,
  SIGNIN,
  SIGNUP,
  SIGNUP_SSO,
  SIGNUP_VERIFY,
} from "constants/urls";
import { RouteObject } from "react-router-dom";

export default [
  {
    path: SIGNIN,
    lazy: () => import("modules/auth/pages/AuthSignin"),
  },
  {
    path: OAUTH_CALLBACK,
    lazy: () => import("modules/auth/pages/AuthOauthCallback"),
  },
  {
    path: SIGNUP,
    lazy: () => import("modules/auth/pages/AuthSignupManual"),
  },
  {
    path: SIGNUP_SSO,
    lazy: () => import("modules/auth/pages/AuthSignupSso"),
  },
  {
    path: PASSWORD_RESET,
    lazy: () => import("modules/auth/pages/AuthPasswordReset"),
  },
  {
    path: SIGNUP_VERIFY,
    lazy: () => import("modules/auth/pages/AuthSignUpVerify"),
  },
] as RouteObject[];
